var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_vm._l((_vm.widgetData.widgets),function(widget,index){return [_c('b-col',{key:index,staticClass:"column",attrs:{"cols":widget.columns}},[_c('widget-inner',{attrs:{"widget-data":widget}})],1)]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }